// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"2c41d653","603":"5828c3ef","664":"0b9d5434"}[chunkId] + ".chunk.css";
};